import {getPadding} from '@styles/tokens';
import {useMemo} from 'react';
import {useWindowSize} from 'react-use';

export default function useMeasureCols(ITEM_WIDTH: number, ITEM_MARGIN: number): number {
  const { width } = useWindowSize();

  return useMemo(() => {
    const padding = getPadding(width);
    const computedValue = Math.floor((width - padding * 2) / (ITEM_WIDTH + ITEM_MARGIN));
    const val = computedValue > 0 ? computedValue : 1;

    return val;
  }, [width]);
}
